// extracted by mini-css-extract-plugin
export default {"spinner":"h1TVK3uDb6ND5rHN7ruuKg=="};